import {fromJS} from 'immutable';
import * as types from 'constants/action-types';
import {
  setRecordsReducer,
  setCurrentRecordPageReducer,
  setCurrentRecordReducer,
  clearRecordsAfterPageReducer,
} from './base';

const initialState = fromJS({
  tipPages: {
    currentPage: 1,
    totalCount: 0,
    pageCount: 1,
    itemsPerPage: 0,
  },
  currentTip: {},
  scrollableTipPages: {
    readings: {},
    pageIds: [],
    currentPage: 0,
    totalPages: 1,
    hasNext: true,
  },
});

const setTipsReducer = (state, action) => setRecordsReducer('tip', state, action);

const setCurrentTipPageReducer = (state, action) => setCurrentRecordPageReducer('tip', state, action);

const setCurrentTipReducer = (state, action) => setCurrentRecordReducer('tip', state, action);

const clearTipsAfterPageReducer = (state, action) => clearRecordsAfterPageReducer('tip', state, action);

const setScrollableTipsReducer = (state, action) =>
  state
    .setIn(['scrollableTipPages', 'currentPage'], action.nextPage)
    .setIn(['scrollableTipPages', 'totalPages'], action.pageCount)
    .setIn(['scrollableTipPages', 'hasNext'], action.pageCount - action.nextPage > 0)
    .setIn(['scrollableTipPages', 'tips', action.nextPage], fromJS(action.records))
    .setIn(['scrollableTipPages', 'pageIds'], state.getIn(['scrollableTipPages', 'pageIds']).push(action.nextPage));

const clearScrollableTipsReducer = () => initialState;

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.REINITIALIZE_STORE_STATE:
      return initialState;
    case types.SET_TIPS:
      return setTipsReducer(state, action);
    case types.SET_CURRENT_TIP_PAGE:
      return setCurrentTipPageReducer(state, action);
    case types.SET_CURRENT_TIP:
      return setCurrentTipReducer(state, action);
    case types.CLEAR_TIPS_AFTER_PAGE:
      return clearTipsAfterPageReducer(state, action);
    case types.SET_SCROLLABLE_TIPS:
      return setScrollableTipsReducer(state, action);
    case types.CLEAR_SCROLLABLE_TIPS:
      return clearScrollableTipsReducer();
    default:
      return state;
  }
};
